import React from "react";

const Policy = () => {
  return (
    <div>
      <p> Effective Date: 16.07.2023</p>
      Our food ordering app ("App") is committed to protecting your privacy.
      This Privacy Policy explains how we collect, use, and disclose your
      personal information when you use our App. By using our App, you consent
      to the collection, use, and disclosure of your personal information as
      described in this Privacy Policy.
      <ol>
        <li>
          Information We Collect: Personal Information: We may collect the
          following personal information when you use our App: Name Contact
          information (email address, phone number) Delivery address
        </li>
        <li>
          Usage Information: We may collect non-personal information about how
          you use our App, such as: How We Use Your Information:
        </li>
        <li>
          Providing Services: We use your personal information to provide you
          with the services you request through our App, including processing
          your orders, delivering food, and facilitating payments.
        </li>
        <li>
          Improving User Experience: We may use your information to enhance and
          personalize your experience with our App, including improving our
          services, developing new features, and optimizing our App's
          performance.
        </li>
        <li>
          Communication: We may use your contact information to communicate with
          you regarding your orders, account updates, promotional offers, and
          other service-related information.
        </li>
        <li>
          Legal Compliance: We may use your information to comply with
          applicable laws, regulations, or legal processes, or to respond to
          requests from governmental or public authorities.
        </li>
        <li>
          Legal Requirements: We may disclose your information if required to do
          so by law or in response to valid legal requests, such as subpoenas or
          court orders.
        </li>
        <li>
          Business Transfers: In the event of a merger, acquisition, or sale of
          our business assets, your information may be transferred to the
          acquiring entity as part of the transaction. Security: We implement
          reasonable security measures to protect your personal information from
          unauthorized access, alteration, disclosure, or destruction. However,
          no method of transmission over the Internet or electronic storage is
          100% secure, and we cannot guarantee absolute security. Children's
          Privacy: Our App is not intended for use by individuals under the age
          of 13. We do not knowingly collect personal information from children.
          If you believe that we have inadvertently collected information from a
          child, please contact us immediately. Updates to this Privacy Policy:
          We reserve the right to update this Privacy Policy from time to time.
          We will notify you of any material changes by posting the updated
          Privacy Policy on our App. Your continued use of the App following the
          changes constitutes your acceptance of the updated Privacy Policy.
        </li>
      </ol>
      Contact Us: If you have any questions or concerns about this Privacy
      Policy or our privacy practices, please contact us at{" "}
      <a href="https://restobaba.onrender.com">RestoBABA</a>. Remember to
      customize this Privacy Policy to reflect the specific practices and
      requirements of your food ordering app. It's advisable to seek legal
      advice to ensure compliance with relevant privacy laws and regulations.
    </div>
  );
};

export default Policy;
